// extracted by mini-css-extract-plugin
export default {"input":"Input_input__Fv+Jc","inputContainer":"Input_inputContainer__h8-5E","magnifyingGlassIcon":"Input_magnifyingGlassIcon__Nzd5h","defaultStyles":"Input_defaultStyles__FIhll"};